<template>
  <div>
    <a-drawer
      title="Create a new key"
      width="60%"
      @close="onClose"
      :visible="isDrawerVisible"
      :wrapStyle="{height: 'calc(100% - 108px)',overflow: 'auto',paddingBottom: '108px'}"
    >
    <a-spin size="large" :spinning="loading">
      <a-form :form="form" :layout="formLayout" style="margin-top:1em;" class="create_tenant">
        <a-select-field
        varName="key_algorithm"
        varLabel="Key Type"
        :varRequired="true"
        :formLayout="formLayout"
        :size="size"
        :varOptions="keyTypes"
        type="array"
        />
        <a-switch-field
          varName="is_default"
          varLabel="Is a default key?"
          :varRequired="false"
          :formLayout="formLayout"
          :size="size"
          description="If there are several active keys of same type, default key will be used for signing and encrypting the payloads. You can always update this option after creating the key."
        />
        <a-submit-button
          @submit="handleSubmit"
          :formLayout="formLayout"
          btn_text="Create Key"
          styled="margin-top:0.5em;"
        />
      </a-form>
      </a-spin>
    </a-drawer>
  </div>
</template>

<script>

export default {
  data() {
    return {
      form: this.$form.createForm(this),
      formLayout: "vertical",
      size: "large",
      loading: false
    };
  },
  methods: {
    onClose() {
      this.$store.dispatch("ui/hideDrawer", {
        drawer_name: "create_key"
      });
    },
    handleSubmit() {
      const form = this.form;
      form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.loading = true;
            await this.$store.dispatch("tenant/createItem", {
              endpoint: "keys",
              data: values
            });
            this.loading = false;
            await this.$store.dispatch("ui/hideDrawer", {
              drawer_name: "create_key"
            });
            await this.$store.dispatch("tenant/getItems", {
                endpoint: "keys"
            });
            await this.$notification.open({
                message: 'New key created!',
                description: 'You can now update your new key.',
                icon: <a-icon type="check-circle" theme="filled" style="color: green" />
            });
          } catch (error) {
            console.error(error);
            this.loading = false;
          }
        } else {
          console.error("Error! Check submitted values: ", values);
        }
      });
    }
  },
  computed: {
    isDrawerVisible() {
      return this.$store.state.ui.create_key;
    },
    keyTypes() {
      return ['oct', 'RSA', 'EC']
    }
  }
};
</script>
